module.exports = __webpack_public_path__ + "static/img/3.1be8a14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/images/3.png
// module id = hj1F
// module chunks = 1